import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import {
    DashboardOutlined,
    SolutionOutlined,
    UserAddOutlined,
    FileAddOutlined,
    FileSearchOutlined,
    MenuOutlined, 
    FileTextOutlined
  } from '@ant-design/icons';

const { Sider } = Layout;

const Sidebar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const handleMouseEnter = () => {
    setCollapsed(false);
  };

  const handleMouseLeave = () => {
    setCollapsed(true);
  };

  return (
      <Sider
        width={"15%"}
        theme="dark"
        // collapsed={collapsed}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div style={{ textAlign: 'center', lineHeight: '64px', color: '#fff', borderBottom: '1px solid #2c3e50'}}>
          <p style={{ fontSize: '18px', fontWeight: 'bold' }}>ADMIN</p>
        </div>


        <Menu mode="vertical" theme="dark" selectedKeys={[location.pathname]}>
        <Menu.Item key="/dashboard" icon={<DashboardOutlined />}>
          <Link to="/dashboard">Dashboard</Link>
        </Menu.Item>

        <Menu.Item key="/report" icon={<FileSearchOutlined />}>
          <Link to="/report">Report</Link>
        </Menu.Item>

        <Menu.Item key="/view_edit_customer" icon={<SolutionOutlined />}>
          <Link to="/view_edit_customer">Company Profile</Link>
        </Menu.Item>

        <Menu.Item key="/view_customer_viewer" icon={<MenuOutlined />}>
          <Link to="/view_customer_viewer">Company Viewer</Link>
        </Menu.Item>

        <Menu.Item key="/view_edit_contract" icon={<FileTextOutlined />}>
          <Link to="/view_edit_contract">Subscription Details</Link>
        </Menu.Item>

        <Menu.Item key="/add_user" icon={<UserAddOutlined />}>
          <Link to="/add_user">Add Admin</Link>
        </Menu.Item>
            
        </Menu>
      </Sider>
  );
};

export default Sidebar;
